<template>
  <div>
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Line } from 'vue-chartjs';

export default {
  extends: Line,

  props: {
    labels: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    dataLabel: {
      type: String,
      default: '',
    },
  },

  mounted() {
    this.renderChart(
      {
        labels: this.labels,
        datasets: [
          {
            label: this.dataLabel,
            data: this.data,

            borderColor: '#378ADD',
            backgroundColor: 'rgba(55,138,221,0.1)',

            fill: true,
            lineTension: 0, // smooth curve
            pointRadius: 4,
            pointHoverRadius: 6,
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,

        legend: {
          display: false,
          position: 'top',
        },

        tooltips: {
          callbacks: {
            label: (tooltipItem) => {
              return `Total: ${tooltipItem.yLabel}`;
            },
          },
        },

        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
    );
  },
};
</script>

<style scoped>
div {
  height: 100%;
}
</style>
